<template>
  <section id="titleScr">
    <div id="titleScrDescr">
      <div id="alterH1">
        <p>Займы до <span>100 000 ₽ <svg viewBox="0 0 195 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.092.17C7.658.78 2.29 2.912.414 8.731c-.494 1.559-.517 1.828-.222 3.892.173 1.253.345 2.301.368 2.37.023.068.418-.443.885-1.085.69-1.048 1.158-1.354 3.155-2.033 3.177-1.116 6.232-1.49 14.901-1.896 10.15-.474 64.117-1.048 124.39-1.322 27.638-.137 50.446-.337 50.691-.505.223-.137.418-.406.418-.543 0-.779-10.122-2.301-24.633-3.691-15.591-1.522-25-1.896-61.825-2.402-13.621-.205-31.01-.505-38.672-.68C62.21.67 51.47.433 45.977.333c-5.492-.1-11.75-.237-13.916-.305-2.17-.069-6.65 0-9.977.137l.008.005z" fill="#ABE600"/></svg></span> без кредитной истории</p></div>
      <ul>
        <li>
          <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.253.211c-1.153.214-2.444.59-2.899.862C1.067 1.827.128 3.388.019 5c-.134 1.695.43 2.879 1.88 4.06.885.698 1.286.832 2.899.916 1.34.08 2.226-.025 3.116-.352 3.813-1.452 5.317-5.62 2.953-8.148C9.551.048 8.127-.275 5.257.211h-.004zm2.122 4.332c.134.376-1.103.916-2.093.916-1.073 0-.885-.565.322-.996 1.048-.376 1.637-.351 1.77.08z" fill="#ABE600"/></svg>
          <p>Более 1 000 000 клиентов</p>
        </li>
        <li>
          <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.253.211c-1.153.214-2.444.59-2.899.862C1.067 1.827.128 3.388.019 5c-.134 1.695.43 2.879 1.88 4.06.885.698 1.286.832 2.899.916 1.34.08 2.226-.025 3.116-.352 3.813-1.452 5.317-5.62 2.953-8.148C9.551.048 8.127-.275 5.257.211h-.004zm2.122 4.332c.134.376-1.103.916-2.093.916-1.073 0-.885-.565.322-.996 1.048-.376 1.637-.351 1.77.08z" fill="#ABE600"/></svg>
          <p>Быстрая и удобная регистрация</p>
        </li>
        <li>
          <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.253.211c-1.153.214-2.444.59-2.899.862C1.067 1.827.128 3.388.019 5c-.134 1.695.43 2.879 1.88 4.06.885.698 1.286.832 2.899.916 1.34.08 2.226-.025 3.116-.352 3.813-1.452 5.317-5.62 2.953-8.148C9.551.048 8.127-.275 5.257.211h-.004zm2.122 4.332c.134.376-1.103.916-2.093.916-1.073 0-.885-.565.322-.996 1.048-.376 1.637-.351 1.77.08z" fill="#ABE600"/></svg>
          <p>Удобные способы возврата</p>
        </li>
      </ul>
      <div id="girlImg" v-bind:style="cssProps"></div>
    </div>
    <div>
      <instAmountSelector></instAmountSelector>
      <div id="eseaAlign">
        <esia></esia>
      </div>

    </div>

  </section>
</template>

<script>

export default {
  name: "titleScreen",
  data(){
    return {
      cssProps: {
        backgroundImage: `url(${require('@/assets/images/girl25.png')})`
      }
    }
  },
  components:{
    instAmountSelector: () => import('@/components/inst/instAmountSelector.vue'),
    esia: () => import('@/components/esia.vue'),
  }
}
</script>

<style scoped>
#titleScr{padding-top: var(--font-size-40);}
#titleScrDescr{width: var(--block-width-with-padding-20);margin: 0 auto;position: relative;min-height: var(--font-size-433);}
#titleScrDescr #alterH1{font-weight: bold;font-size: var(--font-size-38);text-transform: uppercase;color:var(--color-black-type2);padding-bottom: var(--font-size-40)}
#titleScrDescr #alterH1 span{display: inline-block;position: relative;}
#titleScrDescr #alterH1 span svg{position: absolute;bottom:0;left:0;width: 115%;height: auto;z-index: -1;}
#titleScrDescr ul{color:var(--color-gray-type3);font-size: var(--font-size-16)}
#titleScrDescr ul li{margin-top: var(--font-size-16);width: var(--font-size-160);position: relative;padding-left: var(--font-size-21)}
#titleScrDescr ul li svg{position: absolute;left:0;top:0;width: var(--font-size-12);height: var(--font-size-18)}
#girlImg{width: var(--font-size-221);height: var(--font-size-351);background-size: cover;background-position: center;background-repeat: no-repeat;position: absolute;right: 0;bottom: 0;}
#eseaAlign{margin:var(--font-size-30) auto;width: var(--font-size-351);}
/deep/#eseaAlign p {font-weight: bolder}
@media screen and (min-width: 760px) {
  #titleScr{display: flex;align-items: flex-start;justify-content: flex-start;min-height: var(--font-size-618)}
  #titleScrDescr{margin: 0;width: var(--font-size-690)}
  #titleScrDescr #alterH1{font-size: var(--font-size-42);width: var(--font-size-460)}
  #titleScrDescr ul{font-size: var(--font-size-18)}
  #girlImg{width: var(--font-size-375);height: var(--font-size-595);right: calc(-1 * var(--font-size-33));top:var(--font-size-24);bottom: auto;}
  #titleScrDescr ul li{width: 100%;}
  #eseaAlign{margin: var(--font-size-30) 0 0 var(--font-size-24)}
}
</style>